import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get companies
 * */
export function* getCompanies() {
    const response = yield call(api.getCompanies);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_COMPANIES.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_COMPANIES.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetCompanies() {
    while (true) {
        yield take(actionTypes.GET_COMPANIES.REQUEST);
        yield fork(getCompanies);
    }
}

export default [
    watchGetCompanies,
];




// WEBPACK FOOTER //
// ./app/sagas/companies.js